import { Locale } from "@redotech/crdb-enums/common/locale";
import * as z from "zod";

export const TRANSLATE_FLOW_ELEMENT_ENTRIES_LIMIT = 30;

/**
 * Machine-translates a flow element's authored strings into the target
 * languages, producing an editable starting point for the merchant. Each
 * entry's caller-defined `key` (the translatable field name) is echoed back
 * so the client can map translations into its editor state; nothing is
 * persisted until the merchant saves.
 *
 * Bounds mirror translateSpotlightBlock: an element has at most a few
 * translatable fields and the language list is the fixed locale set (~13).
 */
export const translateFlowElementText = {
  name: "translateFlowElementText" as const,
  input: z.object({
    entries: z
      .array(
        z.object({ key: z.string().max(200), message: z.string().max(5000) }),
      )
      .max(TRANSLATE_FLOW_ELEMENT_ENTRIES_LIMIT),
    targetLanguages: z.array(z.enum(Locale)).max(20),
  }),
  output: z.object({
    // language code → entry key → translated string
    translations: z.record(z.string(), z.record(z.string(), z.string())),
  }),
};
